export default "__VITE_PUBLIC_ASSET__76527c9d__"